import { Component } from '@angular/core';

@Component({
  selector: 'td-wb-table-card-column',
  templateUrl: 'table-card-column.component.html',
  styleUrls: ['table-card-column.component.scss']
})
export class TableCardColumnComponent {
}
